"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Value = exports.Title = exports.Row = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Row = styled_components_1.default.div `
  display: flex;
  grid-template-columns: 13em repeat(${({ $numberOfColumns }) => $numberOfColumns}, 1fr) 4em;
  width: 100%;
  background-color: ${colors_1.LIGHT_GREY};
  background-color: ${({ $isHeader }) => !$isHeader && colors_1.WHITE};

  & article {
    flex: 1;
    color: ${colors_1.GREY4};
    border-top: 1px solid ${colors_1.GREY1};
    border-left: 1px solid ${colors_1.GREY1};
    padding: 12px 2px;
    margin: 0;
    font-size: 14px;
    background-color: ${({ $isHeader }) => !$isHeader && colors_1.WHITE};
    font-weight: ${({ $isHeader }) => $isHeader && "bold"};

    text-overflow: ellipsis;
    overflow: hidden;
    height: 1.2em;
    white-space: nowrap;

    &:first-child,
    label {
      padding: 12px 8px;
      flex: 4;
      font-weight: 700;
      font-size: 14px;

      @media (width <= 687px) {
        flex: 2;
      }
    }

    &:last-child,
    label {
      flex: 2;
      font-weight: 700;
      font-size: 14px;
    }
  }
`;
exports.Title = styled_components_1.default.article `
  font-size: 16px;
  margin-left: 16px;
`;
exports.Value = styled_components_1.default.article `
  text-align: center;
  font-size: 16px;
`;
//# sourceMappingURL=SoundValueRow.styles.js.map